<script setup lang="ts">
import { Link } from '@/shared/ui/Link'
import { Stack } from '@/shared/ui/Stack'
import { TermsModal } from '@/shared/ui/TermsModal'

import { TERMS_URL } from '@/apps/adok/shared/config/product'

import { useAcceptTerms } from '../model/useAcceptTerms'

const { open, submitting, accept } = useAcceptTerms()
</script>

<template>
  <TermsModal
    :model-value="open"
    :submitting="submitting"
    align-center
    @accept="accept"
  >
    <Stack :gap="16" class="accept-terms-modal__body">
      <p>
        Before you carry on, please read and accept adok's
        <Link
          :href="TERMS_URL"
          type="primary"
          strong
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms and Conditions </Link
        >.
      </p>
      <p>
        If you disagree with them, talk to your personal manager before
        accepting.
      </p>
    </Stack>
  </TermsModal>
</template>

<style lang="scss" scoped>
.accept-terms-modal__body {
  line-height: 1.6;

  p {
    margin: 0;
  }
}
</style>
